<template>
    <div>
        <v-layout wrap v-if="sortedFields.length">
			<template v-for="field in sortedFields">
		        <field-input
                    ref="field"
                    :key="field.id"
					:assignment_type="assignment_type"
					:assignment_id="assignment_id"
				    :availableassignments="availableassignments ? availableassignments[field.id] : null"
					:column="columns[field.internal_name]"
					:field="field"
					:inlineEdit="inlineEdit"
					:inlineSave="inlineSave"
					:keyedFieldvalues="keyedFieldvalues"
                    :overrideConfig="(overrides ? overrides[field.id] : null)"
					:setDefault="setDefault"
					:value="keyedFieldvalues[field.id]"
					:viewform="viewform"
                    :editDisabled="editDisabled"
					@inputChanged="$emit('inputChanged', $event)"
                    @createCustomer="$emit('createCustomer', $event)"></field-input>
			</template>
        </v-layout>
        <template v-for="(value, key, index) in sortedFieldGroups">
            <v-divider class="my-4" :key="index" v-if="sortedFields.length || index > 0"></v-divider>
            <component v-if="key !== 'fields' && value.fields.length" :key="'c'+key" :is="(card ? 'v-card-text' : 'span')">
				<div class="headline">
					{{ value.title }}
				</div>
				<v-layout wrap>
					<template v-for="field in value.fields">
		                <field-input
                            :key="field.id"
							:assignment_type="assignment_type"
							:assignment_id="assignment_id"
				            :availableassignments="availableassignments ? availableassignments[field.id] : null"
							:column="columns[field.internal_name]"
							:field="field"
							:inlineEdit="inlineEdit"
					        :inlineSave="inlineSave"
							:keyedFieldvalues="keyedFieldvalues"
                            :overrideConfig="(overrides ? overrides[field.id] : null)"
							:setDefault="setDefault"
							:value="keyedFieldvalues[field.id]"
							:viewform="viewform"
                            :editDisabled="editDisabled"
							@inputChanged="$emit('inputChanged', $event)"
                            @createCustomer="$emit('createCustomer', $event)"></field-input>
					</template>
	            </v-layout>
            </component>
        </template>
    </div>
</template>

<script>
    import FieldInput from './FieldInput';

    export default {
        data() {
            return {}
        },
        components: {
            'field-input': FieldInput
        },
        computed: {
            keyedFieldgroups () {
                let groups = {};
				if(this.fieldgroups) {
					this.fieldgroups.forEach(group => {
						groups[group.id] = group.name;
					})
				}
                return groups;
            },
            sortedFields () {
                let sortedfields = [];

                if(this.fields){
                    this.fields.forEach(field => {
                        if(!field.fieldgroup_id){
                            sortedfields.push(field);
                        }
                    });
                }

                return sortedfields;
            },
            sortedFieldGroups () {
                let sortedfields = {};

                if(this.fields){
                    this.fields.forEach(field => {
                        if(field.fieldgroup_id){
                            if(!sortedfields['fg'+field.fieldgroup_id]){
                                sortedfields['fg'+field.fieldgroup_id] = {
                                    title: this.keyedFieldgroups[field.fieldgroup_id],
                                    fields: []
                                };
                            }
                            sortedfields['fg'+field.fieldgroup_id].fields.push(field);
                        }
                    });
                }

                return sortedfields;
            }
        },
        props: {
			assignment_type: String,
            assignment_id: Number,
            availableassignments: Object,
            card: Boolean,
			columns: {
				type: Object,
				default: () => { return {}; }
			},
            fields: Array,
            fieldgroups: Array,
			inlineEdit: Boolean,
			inlineSave: Boolean,
			keyedFieldvalues: Object,
            overrides: Object,
			setDefault: Boolean,
            viewform: Boolean,
            editDisabled: Boolean
		}
    }
</script>
